export const chunkArray = (arr: any[], size: number) =>
	arr.reduce((result, item, index) => {
		if (index % size === 0) result.push([]);

		result[result.length - 1].push(item);

		return result;
	}, []);

export const chunkArrayCyclic = <T extends { id?: string | number }>(
	arr: T[],
	size: number
): T[][] => {
	if (arr.length === 0 || size <= 0) return [];

	const result: T[][] = [];
	const seenChunks = new Set<string>();
	let pointer = 0;

	while (result.length <= arr.length) {
		const chunk: T[] = [];

		for (let i = 0; i < size; i++) chunk.push(arr[(pointer + i) % arr.length]);

		const key = chunk.map(item => item.id ?? JSON.stringify(item)).join('|');

		if (seenChunks.has(key)) break;

		seenChunks.add(key);
		result.push(chunk);
		pointer = (pointer + size) % arr.length;
	}

	return result;
};

export const getMaxWidthSnapshot = (maxWidth?: number) =>
	maxWidth !== undefined && window.matchMedia(`(max-width: ${maxWidth}px)`).matches;

export const getMaxWidthServerSnapshot = () => false;

const subscribeMaxWidth = (maxWidth: number | undefined, onStoreChange: () => void) => {
	if (maxWidth === undefined) return () => undefined;

	const mediaQuery = window.matchMedia(`(max-width: ${maxWidth}px)`);
	mediaQuery.addEventListener('change', onStoreChange);

	return () => mediaQuery.removeEventListener('change', onStoreChange);
};

const maxWidthSubscribeCache = new Map<string, (onStoreChange: () => void) => () => void>();

export const getMaxWidthSubscribe = (maxWidth?: number) => {
	const key = maxWidth === undefined ? '' : String(maxWidth);
	const cached = maxWidthSubscribeCache.get(key);
	if (cached) return cached;

	const subscribe = (onStoreChange: () => void) => subscribeMaxWidth(maxWidth, onStoreChange);
	maxWidthSubscribeCache.set(key, subscribe);

	return subscribe;
};
